import { SmartControlTestRecord } from '@trustero/trustero-api-web/lib/audit/auditbot_pb'
import { Control } from '@trustero/trustero-api-web/lib/model/control_pb'
import { ModalFormId } from '../../ModalForm'
import { DateRange } from '../../../../pages/AuditBot/AuditBot.hooks'

export enum ControlDisplay {
  FAILED = 'failed',
  STALE = 'stale',
  PASSED = 'passed',
  UNKNOWN = 'unknown',
  NOT_RUN = 'not-run',
  ALL = 'all',
  NONE = 'none',
  MISSING_CHECKS = 'missing-checks',
}

export enum ButtonConfig {
  ALL = 'all',
  NONE = 'none',
  DEFAULT = 'default',
}

export type DisplayConfig = {
  buttonConfig: ButtonConfig
  showResults: boolean
}

export type AuditScanModalContextType = {
  // Relevant Audit
  auditId: string
  setAuditId: React.Dispatch<React.SetStateAction<string>>

  // Modal State
  title: string
  setTitle: React.Dispatch<React.SetStateAction<string>>
  description: string | JSX.Element
  setDescription: React.Dispatch<React.SetStateAction<string | JSX.Element>>
  onBackModalId: null | ModalFormId
  setOnBackModalId: React.Dispatch<React.SetStateAction<null | ModalFormId>>

  // Filtering and Selecting
  controlsFilter: ControlDisplay[]
  setControlsFilter: React.Dispatch<React.SetStateAction<ControlDisplay[]>>
  controlsPreselect: ControlDisplay[]
  setControlsPreselect: React.Dispatch<React.SetStateAction<ControlDisplay[]>>

  // manage state for the audit bot modal
  filteredControls: Control[]
  setFilteredControls: React.Dispatch<React.SetStateAction<Control[]>>
  preselectedControlIds: string[]
  setPreselectedControlIds: React.Dispatch<React.SetStateAction<string[]>>

  controlTestMap: Record<string, SmartControlTestRecord>
  setControlTestMap: React.Dispatch<
    React.SetStateAction<Record<string, SmartControlTestRecord>>
  >

  // This can be given directly to the modal
  displayConfig: DisplayConfig
  setDisplayConfig: React.Dispatch<React.SetStateAction<DisplayConfig>>

  singleControlId?: string
  setSingleControlId: React.Dispatch<React.SetStateAction<string | undefined>>

  dateRange: DateRange
  setDateRange: React.Dispatch<React.SetStateAction<DateRange>>

  // This is used for scanning in CC mode
  dateLimit: Date
  setDateLimit: React.Dispatch<React.SetStateAction<Date>>
}

export const AUDIT_SCAN_MODAL_GRID =
  'min-content minmax(min-content, auto) minmax(min-content, auto) minmax(min-content, 6fr) minmax(min-content, 1fr)'

export const SINGLE_CONTROL_AUDIT_SCAN_GRID =
  'min-content minmax(min-content, auto) minmax(min-content, 6fr) minmax(min-content, 1fr)'

export type UseAuditScanModalType = {
  title: string
  description: string | JSX.Element
  controlName?: string
  singleControlId?: string
  auditId?: string
  dateRange?: DateRange
  controlsFilter?: ControlDisplay[]
  controlsPreselect?: ControlDisplay[]
  onBackModalId?: ModalFormId
  displayConfig?: DisplayConfig
}
